import {Action, combineReducers} from "redux";
import {isType} from "typescript-fsa";

import {Ganymede} from "@slices/Ganymede/ClientManager";
import {loadingReducer} from "src/utils/reducers";

import {
  getClients, projectRoute, createClientClicked, newClientNameChanged,
  cancelCreateClicked, createClient, clientClicked, clientDialogClosed,
  createClientToken,
} from "./Project.actions";


const clients = (state: Ganymede.Client[] | null = null,
                 action: Action): Ganymede.Client[] | null => {
  if (isType(action, getClients.done))
    return action.payload.result;

  if (isType(action, projectRoute.leaved))
    return null;

  if (isType(action, createClient.done))
    return [...(state || []), action.payload.result];

  return state;
};


const createDialogOpen = (state: boolean = false, action: Action): boolean => {
  if (isType(action, createClientClicked))
    return true;

  if (isType(action, cancelCreateClicked))
    return false;

  if (isType(action, createClient.done))
    return false;

  return state;
};

const newClientName = (state: string = '', action: Action): string => {
  if (isType(action, newClientNameChanged))
    return action.payload;

  if (isType(action, cancelCreateClicked))
    return '';

  if (isType(action, createClient.done))
    return '';

  return state;
};

const isCreating = loadingReducer(createClient);

const selectedClientRow = (state: number | null = null,
                           action: Action): number | null => {
  if (isType(action, clientClicked))
    return action.payload.row;

  if (isType(action, clientDialogClosed))
    return null;

  return state;
};

const clientToken = (state: string | null = null,
                     action: Action): string | null => {
  if (isType(action, createClientToken.done))
    return action.payload.result.token;

  if (isType(action, clientDialogClosed))
    return null;

  return state;
};

export interface ProjectState {
  clients: Ganymede.Client[] | null;
  createDialogOpen: boolean;
  newClientName: string;
  isCreating: boolean;
  selectedClientRow: number | null;
  clientToken: string | null;
}

export default combineReducers({
  clients,
  createDialogOpen,
  newClientName,
  isCreating,
  selectedClientRow,
  clientToken,
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/projects/project/reducer.ts